import { isEmpty, type TeamData, type TeamId } from '@terros/common'

/**
 * Enrollment filters a program's scope against the upline of the team that fired the trigger
 * (see teamMemberStream in api-plan), and that upline is inclusive. A team trigger can therefore
 * only ever fire when a scope team sits on the same branch as the trigger team — either above it
 * (joining the trigger team is in scope) or below it (joining that sub team fires the trigger).
 * A scope team on an unrelated branch leaves the trigger permanently unreachable.
 */
export function isTeamTriggerReachable({
  triggerTeamId,
  scopeTeamIds,
  teams,
}: {
  triggerTeamId: TeamId
  scopeTeamIds: TeamId[]
  teams: TeamData[]
}): boolean {
  if (isEmpty(scopeTeamIds)) return true

  const triggerTeam = teams.find((team) => team.teamId === triggerTeamId)
  if (!triggerTeam) return true

  return scopeTeamIds.some((scopeTeamId) => {
    if (scopeTeamId === triggerTeamId) return true
    if (triggerTeam.parentTeamIds.includes(scopeTeamId)) return true
    const scopeTeam = teams.find((team) => team.teamId === scopeTeamId)
    return scopeTeam?.parentTeamIds.includes(triggerTeamId) ?? false
  })
}
